var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2024-09-09
 * @brief SEI 에너지솔루션 관리 - 가견적서 데이터 관리 개발
 *
 ********************************************************************/
import { alertState } from "@recoil/assessmentState";
import { langId } from "@recoil/langState";
import { loadingBoxState } from "@recoil/menuState";
import { reLoad, userInfoLoginState } from "@recoil/userState";
import { useText } from "@utils/langs/useTrans";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import EhpPagination from "@components/common/pagination/EhpPagination";
import * as HTTPUTIL from "@utils/api/HttpUtil";
import * as CUTIL from "@utils/commUtils";
import * as CONST from "@utils/Const";
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
//압축 다운로드
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
export default function DataManagementFromProspectiveDocument(props) {
    // Trans
    const t = useText();
    const navigate = useNavigate();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    const [reload, setReload] = useRecoilState(reLoad);
    //props
    const { handleOpenPop } = props;
    const [evCodeItem, setEvCodeItem] = useState([]);
    const [evCode, setEvCode] = useState(null);
    const [subEvCodeItem, setSubEvCodeItem] = useState([]);
    const [subEvCode, setSubEvCode] = useState(null);
    const [typeEvCodeItem, setTypeEvCodeItem] = useState([]);
    const [typeEvCode, setTypeEvCode] = useState(null);
    const [evListItem, setEvListItem] = useState([]);
    const [maskedIds, setMaskedIds] = useState([]);
    const [evEidt, setEvEidt] = useState(false);
    const [title, setTitle] = useState(null);
    const [pop01Re, setPop01Re] = useState(false);
    const [pop02Re, setPop02Re] = useState(false);
    useEffect(() => {
        // 데이터 추가 팝업
        handleOpenPop("pop-01", _jsx(Pop01, { pop01Re: pop01Re, setPop01Re: setPop01Re, title: title, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: "\uB370\uC774\uD130 \uCD94\uAC00" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Colse("pop-01") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 데이터 수정 팝업
        handleOpenPop("pop-02", _jsx(Pop02, { pop02Re: pop02Re, setPop02Re: setPop02Re, title: title, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: "\uB370\uC774\uD130 \uC218\uC815" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Colse("pop-02") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
    }, [pop01Re, pop02Re, title]);
    const Pop01Opne = (e) => {
        const headItem = {
            code: evCode,
            sub: subEvCode,
            type: typeEvCode,
        };
        setTitle(headItem);
        CUTIL.jsopen_Popup(e);
    };
    const Pop02Opne = (e, item) => {
        if (!evEidt) {
            const headItem = Object.assign(Object.assign({}, item), { code: evCode, sub: subEvCode, type: typeEvCode });
            setTitle(headItem);
            CUTIL.jsopen_Popup(e);
        }
    };
    // 팝업 닫기
    const Colse = (id) => {
        if (id == "pop-01") {
            setPop01Re(true);
        }
        else {
            setPop02Re(true);
        }
        CUTIL.jsclose_Popup(id);
    };
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
        EvList(subEvCode, typeEvCode, page);
    }
    // code API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/codes`,
        appQuery: {
            langId: langIds,
            groupCode: "EV",
        },
        userToken: userInfo.loginInfo.token,
        watch: langIds,
    });
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setEvCodeItem(data.body);
                SubCodeData(data.body[1]);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    }, [data, langIds]);
    useEffect(() => {
        if (reload) {
            EvList(subEvCode, typeEvCode, 0);
        }
    }, [reload]);
    // sub Code API
    const SubCodeData = (item) => __awaiter(this, void 0, void 0, function* () {
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "GET",
            appPath: `/codes`,
            appQuery: {
                langId: langIds,
                groupCode: item.code,
            },
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSubEvCodeItem(data.body);
                setEvCode(item);
                TypeCodeData(data.body[0]);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
        }
    });
    // type Code API
    const TypeCodeData = (item) => __awaiter(this, void 0, void 0, function* () {
        setRecoilIsLoadingBox(true);
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "GET",
            appPath: `/codes`,
            appQuery: {
                langId: langIds,
                groupCode: "EV_TYPE",
            },
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSubEvCode(item);
                setTypeEvCodeItem(data.body);
                TypeSelect(item, data.body[0]);
                setRecoilIsLoadingBox(false);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    });
    // typeCoed 선택
    const TypeSelect = (item, value) => {
        setTypeEvCode(value);
        EvList(item, value, 0);
    };
    const EvList = (item, value, number) => __awaiter(this, void 0, void 0, function* () {
        setRecoilIsLoadingBox(true);
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "GET",
            appPath: `/energyreport/evmngt/list`,
            appQuery: {
                powerCode: item.code,
                typeCode: value.code,
                page: number,
                size: pageInfo.size,
            },
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setEvListItem(data.body.list.map((item) => (Object.assign(Object.assign({}, item), { checkedA: data.body.maskedIds
                        .filter((_, idx) => idx == 0)
                        .some((bit) => bit.maskedBit === item.estimateType), checkedB: data.body.maskedIds
                        .filter((_, idx) => idx == 1)
                        .some((bit) => bit.maskedBit === item.estimateType), checkedC: data.body.maskedIds
                        .filter((_, idx) => idx == 2)
                        .some((bit) => bit.maskedBit === item.estimateType), disabledA: !data.body.maskedIds
                        .filter((_, idx) => idx == 0)
                        .some((bit) => bit.maskedBit === item.estimateType), disabledB: !data.body.maskedIds
                        .filter((_, idx) => idx == 1)
                        .some((bit) => bit.maskedBit === item.estimateType), disabledC: !data.body.maskedIds
                        .filter((_, idx) => idx == 2)
                        .some((bit) => bit.maskedBit === item.estimateType) }))));
                setMaskedIds(data.body.maskedIds);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: data.data.page.totalElements })); //5, 10; // psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false,
                setRecoilIsLoadingBox(false);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
            setReload(false);
        }
    });
    // 체크 박스 A
    const EvCheckA = (ehecked, value) => {
        if (evEidt) {
            if (ehecked) {
                setEvListItem(evListItem.map((item) => item.id == value.id
                    ? Object.assign(Object.assign({}, item), { checkedA: ehecked }) : Object.assign(Object.assign({}, item), { disabledA: true })));
                setMaskedIds(maskedIds.concat({ id: value.id, maskedBit: 1 }));
            }
            else {
                setEvListItem(evListItem.map((item, idx) => item.id == value.id
                    ? Object.assign(Object.assign({}, item), { checkedA: ehecked }) : Object.assign(Object.assign({}, item), { disabledA: false })));
                setMaskedIds(maskedIds.filter((item) => item.id !== value.id));
            }
        }
    };
    // 체크 박스 B
    const EvCheckB = (ehecked, value) => {
        if (evEidt) {
            if (ehecked) {
                setEvListItem(evListItem.map((item, idx) => item.id == value.id
                    ? Object.assign(Object.assign({}, item), { checkedB: ehecked }) : Object.assign(Object.assign({}, item), { disabledB: true })));
                setMaskedIds(maskedIds.concat({ id: value.id, maskedBit: 2 }));
            }
            else {
                setEvListItem(evListItem.map((item) => item.id == value.id
                    ? Object.assign(Object.assign({}, item), { checkedB: ehecked }) : Object.assign(Object.assign({}, item), { disabledB: false })));
                setMaskedIds(maskedIds.filter((item) => item.id !== value.id));
            }
        }
    };
    // 체크 박스 C
    const EvCheckC = (ehecked, value) => {
        if (evEidt) {
            if (ehecked) {
                setEvListItem(evListItem.map((item) => item.id == value.id
                    ? Object.assign(Object.assign({}, item), { checkedC: ehecked }) : Object.assign(Object.assign({}, item), { disabledC: true })));
                setMaskedIds(maskedIds.concat({ id: value.id, maskedBit: 4 }));
            }
            else {
                setEvListItem(evListItem.map((item) => item.id == value.id
                    ? Object.assign(Object.assign({}, item), { checkedC: ehecked }) : Object.assign(Object.assign({}, item), { disabledC: false })));
                setMaskedIds(maskedIds.filter((item) => item.id !== value.id));
            }
        }
    };
    // Ev list 수정
    const EvListEidt = (blooean) => __awaiter(this, void 0, void 0, function* () {
        setRecoilIsLoadingBox(true);
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "PUT",
            appPath: `/energyreport/evmngt/select`,
            appQuery: {
                estimateType: maskedIds,
            },
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: data.body, callBack: () => {
                        setEvEidt(blooean);
                        setReload(true);
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    });
    // 엑셀 리스트 API
    const ListExcell = (e) => __awaiter(this, void 0, void 0, function* () {
        setRecoilIsLoadingBox(true);
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "GET",
            appPath: `/energyreport/evmngt/list`,
            appQuery: {
                size: 1,
            },
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                excelDownloadSaved(data.body.list);
            }
        }
    });
    // List Download
    const excelDownloadSaved = (excelData) => {
        const execHeaderList = [
            "용량(kW)",
            "종류",
            "가견적서 설정",
            "제조사",
            "구매자 수익기준",
            "구매자 수익기준 영문",
            "충전소 설치비",
            "위탁 운영비",
            "충전 요금",
            "충전 요금 영문",
            "계약 기간",
            "화재 감지",
            "보험 가입",
            "터치 LCD",
            "신용카드 리더기",
            "간편결제 기능",
            "전용 앱 서비스",
        ];
        //
        const excelFileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"; // 파일 타입 및 유니코드
        const excelFileExtension = ".xlsx"; // 확장자 명
        const excelFileName = `Ev_EstimatedSheet`; // 파일명
        const excelSheet = XLSX.utils.aoa_to_sheet([execHeaderList]);
        // 열 너비를 계산하기 위한 배열 초기화
        const colWidths = execHeaderList.map((header) => header.length);
        excelData.map((sheet, idx) => {
            const row = [
                sheet.power,
                sheet.type,
                sheet.estimateType > 0
                    ? sheet.estimateType == 1
                        ? "A"
                        : sheet.estimateType == 2
                            ? "B"
                            : sheet.estimateType == 4 && "C"
                    : null,
                sheet.custNm,
                sheet.buyProfit,
                sheet.buyProfitEn,
                sheet.istCost,
                sheet.oprCost,
                sheet.chgFee,
                sheet.chgFeeEn,
                sheet.contractDay ? 1 : 0,
                sheet.hasFireDtec ? 1 : 0,
                sheet.hasInsc ? 1 : 0,
                sheet.hasTlcd ? 1 : 0,
                sheet.hasCardReader ? 1 : 0,
                sheet.hasSimplePay ? 1 : 0,
                sheet.hasAppServ ? 1 : 0, // 전용 앱 서비스
            ];
            // 각 행의 데이터 길이를 확인하여 열 너비 업데이트
            row.forEach((cell, index) => {
                colWidths[index] = Math.max(colWidths[index], cell ? cell.toString().length : 0);
            });
            XLSX.utils.sheet_add_aoa(excelSheet, [row], { origin: -1 });
            // 숫자 형식 설정
            if (sheet.istCost !== undefined) {
                const cellRef = XLSX.utils.encode_cell({ c: 6, r: idx + 1 }); // 6은 "충전소 설치비" 열
                excelSheet[cellRef] = { v: sheet.istCost, t: "n", z: "#,##" }; // 숫자 형식
            }
            if (sheet.oprCost !== undefined) {
                const cellRef = XLSX.utils.encode_cell({ c: 7, r: idx + 1 }); // 7은 "위탁 운영비" 열
                excelSheet[cellRef] = { v: sheet.oprCost, t: "n", z: "#,##" }; // 숫자 형식
            }
            excelSheet["!cols"] = colWidths.map((width) => ({ width: width + 5 })); // 여유 공간 추가
            return false;
        });
        // wb == workBook 약자
        const wb = { Sheets: { Sheet: excelSheet }, SheetNames: ["Sheet"] };
        const excelButter = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const excelFile = new Blob([excelButter], { type: excelFileType });
        FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
        setRecoilIsLoadingBox(false);
    };
    // 엑셀 업로드 input
    const ExcelInput = (e) => {
        let input = document.createElement("input");
        input.type = "file";
        input.accept = ".xls,.xlsx";
        input.onchange = (e) => {
            var _a;
            const selectedFile = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
            setRecoilIsLoadingBox(true);
            ExleUPload(selectedFile);
        };
        input.click();
    };
    // 업로드 API
    const ExleUPload = (files) => __awaiter(this, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append("file", files);
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "POSTF",
            appPath: `/energyreport/evEstimate`,
            appQuery: formData,
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setAlerts(Object.assign(Object.assign({}, alerts), { layerId: "false", divTag: data.errorList !== null ? data.body : data.solution, callBack: () => {
                        setReload(true);
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        // HightManagementList(subGroup.spgId, 0);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { layerId: "false", type: CONST.TYPE_NONE, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : data.solution, callBack: () => {
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
        }
        setRecoilIsLoadingBox(false);
    });
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: "\uC804\uAE30\uCC28 \uCDA9\uC804\uAE30 \uAC00\uACAC\uC801\uC11C \uB370\uC774\uD130" })) })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsxs("div", Object.assign({ className: "select code w160", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: evCode && evCode.description })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: evCodeItem &&
                                                            evCodeItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => SubCodeData(list) }, { children: list.description }), "codeList_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "select sub w160", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: subEvCode && subEvCode.description })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: subEvCodeItem &&
                                                            subEvCodeItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => TypeCodeData(list) }, { children: list.description }), "subCode_list" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "select type w160", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: typeEvCode && typeEvCode.description })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: typeEvCodeItem &&
                                                            typeEvCodeItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => TypeSelect(subEvCode, list) }, { children: list.description }), "typeCodList_" + idx.toString()))) })] }))] })) })) })), _jsxs("div", Object.assign({ className: "right" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray js-open", disabled: evEidt, "data-pop": "pop-01", onClick: (e) => Pop01Opne(e) }, { children: _jsx("span", { children: "\uB370\uC774\uD130 \uCD94\uAC00" }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", disabled: evEidt, onClick: (e) => ListExcell(e) }, { children: _jsx("span", { children: "Excel \uB2E4\uC6B4\uB85C\uB4DC" }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", disabled: evEidt, onClick: (e) => ExcelInput(e) }, { children: _jsx("span", { children: "Excel \uC5C5\uB85C\uB4DC" }) })), !evEidt ? (_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", onClick: (e) => setEvEidt(true) }, { children: _jsx("span", { children: "\uAC00\uACAC\uC801\uC11C \uB0B4\uC6A9 \uC124\uC815" }) }))) : (
                                    // <!-- 240906 저장버튼 -->
                                    _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => EvListEidt(false) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) })))] }))] })), _jsx("div", Object.assign({ className: "tbl-list menulist tbl-select scrollX dark" }, { children: _jsxs("table", Object.assign({ className: "wmin-2922", summary: "No, \uCDA9\uC804\uAE30 \uC885\uB958, \uC6A9\uB7C9(kW), \uC885\uB958, A, B, C, \uC81C\uC870\uC0AC(\uD68C\uC0AC), \uAD6C\uB9E4\uC790 \uC218\uC775 \uAE30\uC900, \uAD6C\uB9E4\uC790 \uC218\uC775 \uAE30\uC900 (\uC601\uBB38), \uCDA9\uC804\uC18C \uC124\uCE58\uBE44, \uC704\uD0C1 \uC6B4\uC601\uBE44, \uCDA9\uC804\uC694\uAE08, \uCDA9\uC804\uC694\uAE08 (\uC601\uBB38), \uACC4\uC57D \uAE30\uAC04, \uD654\uC7AC \uAC10\uC9C0, \uBCF4\uD5D8\uAC00\uC785, \uD130\uCE58LED, \uCE74\uB4DC \uB9AC\uB354\uAE30, \uAC04\uD3B8\uACB0\uC81C \uAE30\uB2A5, \uC804\uC6A9 \uC571 \uC11C\uBE44\uC2A4, \uB4F1\uB85D\uC77C\uB85C \uAD6C\uC131\uB41C \uC804\uAE30\uCC28 \uCDA9\uC804\uAE30 \uAC00\uACAC\uC801\uC11C \uB370\uC774\uD130 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "No, \uCDA9\uC804\uAE30 \uC885\uB958, \uC6A9\uB7C9(kW), \uC885\uB958, A, B, C, \uC81C\uC870\uC0AC(\uD68C\uC0AC), \uAD6C\uB9E4\uC790 \uC218\uC775 \uAE30\uC900, \uAD6C\uB9E4\uC790 \uC218\uC775 \uAE30\uC900 (\uC601\uBB38), \uCDA9\uC804\uC18C \uC124\uCE58\uBE44, \uC704\uD0C1 \uC6B4\uC601\uBE44, \uCDA9\uC804\uC694\uAE08, \uCDA9\uC804\uC694\uAE08 (\uC601\uBB38), \uACC4\uC57D \uAE30\uAC04, \uD654\uC7AC \uAC10\uC9C0, \uBCF4\uD5D8\uAC00\uC785, \uD130\uCE58LED, \uCE74\uB4DC \uB9AC\uB354\uAE30, \uAC04\uD3B8\uACB0\uC81C \uAE30\uB2A5, \uC804\uC6A9 \uC571 \uC11C\uBE44\uC2A4, \uB4F1\uB85D\uC77C\uB85C \uAD6C\uC131\uB41C \uC804\uAE30\uCC28 \uCDA9\uC804\uAE30 \uAC00\uACAC\uC801\uC11C \uB370\uC774\uD130 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "56px" } }), _jsx("col", { style: { width: "112px" } }), _jsx("col", { style: { width: "120px" } }), _jsx("col", { style: { width: "112px" } }), _jsx("col", { style: { width: "44px" } }), _jsx("col", { style: { width: "44px" } }), _jsx("col", { style: { width: "44px" } }), _jsx("col", { style: { width: "192px" } }), _jsx("col", { style: { width: "192px" } }), _jsx("col", { style: { width: "192px" } }), _jsx("col", { style: { width: "192px" } }), _jsx("col", { style: { width: "192px" } }), _jsx("col", { style: { width: "240px" } }), _jsx("col", { style: { width: "240px" } }), _jsx("col", { style: { width: "120px" } }), _jsx("col", { style: { width: "120px" } }), _jsx("col", { style: { width: "120px" } }), _jsx("col", { style: { width: "120px" } }), _jsx("col", { style: { width: "120px" } }), _jsx("col", { style: { width: "120px" } }), _jsx("col", { style: { width: "120px" } }), _jsx("col", { style: { width: "120px" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "No" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uCDA9\uC804\uAE30 \uC885\uB958" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uC6A9\uB7C9(kW)" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uC885\uB958" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "A" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "B" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "C" })), _jsx("th", Object.assign({ scope: "col", className: "txt-left" }, { children: "\uC81C\uC870\uC0AC(\uD68C\uC0AC)" })), _jsx("th", Object.assign({ scope: "col", className: "txt-left" }, { children: "\uAD6C\uB9E4\uC790 \uC218\uC775 \uAE30\uC900" })), _jsx("th", Object.assign({ scope: "col", className: "txt-left" }, { children: "\uAD6C\uB9E4\uC790 \uC218\uC775 \uAE30\uC900 (\uC601\uBB38)" })), _jsx("th", Object.assign({ scope: "col", className: "txt-right" }, { children: "\uCDA9\uC804\uC18C \uC124\uCE58\uBE44" })), _jsx("th", Object.assign({ scope: "col", className: "txt-right" }, { children: "\uC704\uD0C1 \uC6B4\uC601\uBE44" })), _jsx("th", Object.assign({ scope: "col", className: "txt-left" }, { children: "\uCDA9\uC804\uC694\uAE08" })), _jsx("th", Object.assign({ scope: "col", className: "txt-left" }, { children: "\uCDA9\uC804\uC694\uAE08 (\uC601\uBB38)" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uACC4\uC57D \uAE30\uAC04" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uD654\uC7AC \uAC10\uC9C0" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uBCF4\uD5D8\uAC00\uC785" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uD130\uCE58LCD" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uCE74\uB4DC \uB9AC\uB354\uAE30" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uAC04\uD3B8\uACB0\uC81C \uAE30\uB2A5" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uC804\uC6A9 \uC571 \uC11C\uBE44\uC2A4" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uB4F1\uB85D\uC77C" }))] }) }), _jsx("tbody", { children: evListItem &&
                                        evListItem.map((list, idx) => (_jsxs("tr", Object.assign({ className: "js-open", "data-pop": "pop-02", onClick: (e) => Pop02Opne(e, list) }, { children: [_jsx("td", Object.assign({ className: "txt-center" }, { children: idx + 1 + pageInfo.number * 10 })), _jsx("td", Object.assign({ className: "txt-center" }, { children: list.chargerType })), _jsx("td", Object.assign({ className: "txt-center" }, { children: list.power })), _jsx("td", Object.assign({ className: "txt-center" }, { children: list.type })), _jsxs("td", Object.assign({ className: "txt-center" }, { children: [_jsx("input", { type: "checkbox", id: "a_" + idx, checked: list.checkedA, disabled: list.disabledA, onChange: (e) => EvCheckA(e.target.checked, list) }), _jsx("label", Object.assign({ htmlFor: "a_" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsxs("td", Object.assign({ className: "txt-center" }, { children: [_jsx("input", { type: "checkbox", id: "b_" + idx, checked: list.checkedB, disabled: list.disabledB, onChange: (e) => EvCheckB(e.target.checked, list) }), _jsx("label", Object.assign({ htmlFor: "b_" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsxs("td", Object.assign({ className: "txt-center" }, { children: [_jsx("input", { type: "checkbox", id: "c_" + idx, checked: list.checkedC, disabled: list.disabledC, onChange: (e) => EvCheckC(e.target.checked, list) }), _jsx("label", Object.assign({ htmlFor: "c_" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("td", Object.assign({ className: "txt-left" }, { children: list.custNm })), _jsx("td", Object.assign({ className: "txt-left" }, { children: list.buyProfit })), _jsx("td", Object.assign({ className: "txt-left" }, { children: list.buyProfitEn })), _jsx("td", Object.assign({ className: "txt-right" }, { children: CUTIL.comma(list.istCost) })), _jsx("td", Object.assign({ className: "txt-right" }, { children: CUTIL.comma(list.oprCost) })), _jsx("td", Object.assign({ className: "txt-left" }, { children: list.chgFee })), _jsx("td", Object.assign({ className: "txt-left" }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.chgFeeEn })) })), _jsx("td", Object.assign({ className: "txt-center" }, { children: list.contractDay })), _jsx("td", Object.assign({ className: "txt-center" }, { children: list.hasFireDtec ? "O" : "X" })), _jsx("td", Object.assign({ className: "txt-center" }, { children: list.hasInsc ? "O" : "X" })), _jsx("td", Object.assign({ className: "txt-center" }, { children: list.hasTlcd ? "O" : "X" })), _jsx("td", Object.assign({ className: "txt-center" }, { children: list.hasCardReader ? "O" : "X" })), _jsx("td", Object.assign({ className: "txt-center" }, { children: list.hasSimplePay ? "O" : "X" })), _jsx("td", Object.assign({ className: "txt-center" }, { children: list.hasAppServ ? "O" : "X" })), _jsx("td", Object.assign({ className: "txt-center" }, { children: list.createdTime }))] }), "evList_" + idx.toString()))) })] })) })), _jsx(EhpPagination, { componentName: "EVMANAGEMENT", pageInfo: pageInfo, handleCurPage: handleCurPage })] }))] }));
}
function Pop01(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const setReload = useSetRecoilState(reLoad);
    //
    const { pop01Re, setPop01Re, title } = props;
    //
    const [custNm, setCustNm] = useState("");
    const [buyProfit, setBuyProfit] = useState("");
    const [buyProfitEn, setBuyProfitEn] = useState("");
    const [istCost, setIstCost] = useState("");
    const [oprCost, setOprCost] = useState("");
    const [chgFee, setChgFee] = useState("");
    const [chgFeeEn, setChgFeeEn] = useState("");
    const [contractDay, setContractDay] = useState("");
    const [hasFireDtec, setHasFireDtec] = useState(true);
    const [hasInsc, setHasInsc] = useState(true);
    const [hasTlcd, setHasTlcd] = useState(true);
    const [hasCardReader, setHasCardReader] = useState(true);
    const [hasSimplePay, setHasSimplePay] = useState(true);
    const [hasAppServ, setHasAppServ] = useState(true);
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        CUTIL.IdScrollIntoView("pop-01", "scrollH");
        if (pop01Re) {
            popColes("pop-01");
        }
    }, [pop01Re, title]);
    // 회사명 입력
    const handleCustNm = (e) => {
        setErrorList(errorList.filter((err) => err.field !== "custNm"));
        setCustNm(e.target.value);
    };
    // 구매자 수익 기준 입력
    const handleBuyProfit = (e) => {
        setErrorList(errorList.filter((err) => err.field !== "buyProfit"));
        setBuyProfit(e.target.value);
    };
    // 구매자 수익 기준 영문 입력
    const handleBuyProfitEn = (e) => {
        setErrorList(errorList.filter((err) => err.field !== "buyProfitEn"));
        setBuyProfitEn(e.target.value);
    };
    // 충전소 설치비 입력
    const handleIstCost = (e) => {
        setErrorList(errorList.filter((err) => err.field !== "istCost"));
        setIstCost(CUTIL.inputNum(e.target.value));
    };
    // 위탁운영비 입력
    const handleOprCost = (e) => {
        setErrorList(errorList.filter((err) => err.field !== "oprCost"));
        setOprCost(CUTIL.inputNum(e.target.value));
    };
    // 충전 요금 입려
    const handleChgFee = (e) => {
        setErrorList(errorList.filter((err) => err.field !== "chgFee"));
        setChgFee(e.target.value);
    };
    // 충전 요금 영문 입력
    const handleChgFeeEn = (e) => {
        setErrorList(errorList.filter((err) => err.field !== "chgFeeEn"));
        setChgFeeEn(e.target.value);
    };
    // 계약 기간 입력
    const handleContractDay = (e) => {
        setErrorList(errorList.filter((err) => err.field !== "contractDay"));
        setContractDay(CUTIL.inputNum(e.target.value));
    };
    // 화재 감지 선택
    const handleHasFireDtec = (blooean) => {
        setHasFireDtec(blooean);
    };
    // 보헙가입 선택
    const handleHasInsc = (blooean) => {
        setHasInsc(blooean);
    };
    // 터치LCD 선택
    const handleHasTlcd = (blooean) => {
        setHasTlcd(blooean);
    };
    // 신용카드 리더기 선택
    const handleHasCardReader = (blooean) => {
        setHasCardReader(blooean);
    };
    // 간편결제 기능 선택
    const handleHasSimplePay = (blooean) => {
        setHasSimplePay(blooean);
    };
    // 전용 앱 서비스 선택
    const handleHasAppServ = (blooean) => {
        setHasAppServ(blooean);
    };
    // Ev list 등록
    const EvSaved = (id) => __awaiter(this, void 0, void 0, function* () {
        setRecoilIsLoadingBox(true);
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "POST",
            appPath: `/energyreport/evmngt`,
            appQuery: {
                powerCode: title.sub.code,
                typeCode: title.type.code,
                custNm: custNm,
                buyProfit: buyProfit,
                buyProfitEn: buyProfitEn,
                istCost: istCost,
                oprCost: oprCost,
                chgFee: chgFee,
                chgFeeEn: chgFeeEn,
                contractDay: contractDay,
                hasFireDtec: hasFireDtec,
                hasInsc: hasInsc,
                hasTlcd: hasTlcd,
                hasCardReader: hasCardReader,
                hasSimplePay: hasSimplePay,
                hasAppServ: hasAppServ,
            },
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                popColes(id);
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: "등록이 완료되었습니다.", callBack: () => {
                        setReload(true);
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
            else {
                if (data.errorList !== null) {
                    setErrorList(data.errorList);
                }
                else {
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                setRecoilIsLoadingBox(false);
            }
        }
    });
    // 등록 팝업 닫기
    const popColes = (id) => {
        setCustNm("");
        setBuyProfit("");
        setBuyProfitEn("");
        setIstCost("");
        setOprCost("");
        setChgFee("");
        setChgFeeEn("");
        setContractDay("");
        setHasFireDtec(true);
        setHasInsc(true);
        setHasTlcd(true);
        setHasCardReader(true);
        setHasSimplePay(true);
        setHasAppServ(true);
        setErrorList([]);
        setPop01Re(false);
        CUTIL.jsclose_Popup(id);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body pb-0" }, { children: [title && (_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: title.code.description }), _jsx("li", { children: title.sub.description }), _jsx("li", { children: title.type.description })] }))), _jsxs("div", Object.assign({ className: "mt-32" }, { children: [_jsx("h2", { children: "\uC804\uAE30\uCC28 \uCDA9\uC804\uAE30 \uC815\uBCF4" }), _jsxs("ul", Object.assign({ className: "form__input scrollH h440 pb-30 gap16" }, { children: [_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uC81C\uC870\uC0AC ", _jsx("span", Object.assign({ className: "fontRegular" }, { children: "(\uD68C\uC0AC \uBA85)" }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp1", value: custNm, onChange: (e) => handleCustNm(e), placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", className: `${errorList.filter((err) => err.field == "custNm").length > 0 ? "input-error" : ""}` }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "custNm").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uAD6C\uB9E4\uC790 \uC218\uC775 \uAE30\uC900" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp2", value: buyProfit, onChange: (e) => handleBuyProfit(e), placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: `${errorList.filter((err) => err.field == "buyProfit").length > 0 ? "input-error" : ""}` }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "buyProfit").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uAD6C\uB9E4\uC790 \uC218\uC775 \uAE30\uC900 ", _jsx("span", Object.assign({ className: "fontRegular" }, { children: "(\uC601\uBB38)" }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp3", value: buyProfitEn, onChange: (e) => handleBuyProfitEn(e), placeholder: "\uC601\uBB38\uC73C\uB85C \uC785\uB825\uD558\uC138\uC694.", className: `${errorList.filter((err) => err.field == "buyProfitEn").length > 0 ? "input-error" : ""}` }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "buyProfitEn").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uCDA9\uC804\uC18C \uC124\uCE58\uBE44", _jsx("br", {}), _jsx("span", Object.assign({ className: "fontRegular" }, { children: "(KRW)" }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp4", value: istCost, onChange: (e) => handleIstCost(e), placeholder: "\uC22B\uC790\uB9CC \uC785\uB825\uD558\uC138\uC694.", className: `${errorList.filter((err) => err.field == "istCost").length > 0 ? "input-error" : ""}` }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "istCost").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uC704\uD0C1\uC6B4\uC601\uBE44", _jsx("span", Object.assign({ className: "fontRegular" }, { children: "(KRW)" }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp3", value: oprCost, onChange: (e) => handleOprCost(e), placeholder: "\uC22B\uC790\uB9CC \uC785\uB825\uD558\uC138\uC694.", className: `${errorList.filter((err) => err.field == "oprCost").length > 0 ? "input-error" : ""}` }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "oprCost").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uCDA9\uC804\uC694\uAE08" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp5", value: chgFee, onChange: (e) => handleChgFee(e), placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: `${errorList.filter((err) => err.field == "chgFee").length > 0 ? "input-error" : ""}` }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "chgFee").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uCDA9\uC804\uC694\uAE08 ", _jsx("span", Object.assign({ className: "fontRegular" }, { children: "(\uC601\uBB38)" }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp6", value: chgFeeEn, onChange: (e) => handleChgFeeEn(e), placeholder: "\uC601\uBB38\uC73C\uB85C \uC785\uB825\uD558\uC138\uC694.", className: `${errorList.filter((err) => err.field == "chgFeeEn").length > 0 ? "input-error" : ""}` }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "chgFeeEn").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uACC4\uC57D \uAE30\uAC04" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp7", value: contractDay, onChange: (e) => handleContractDay(e), placeholder: "\uC22B\uC790\uB9CC \uC785\uB825\uD558\uC138\uC694.", className: `${errorList.filter((err) => err.field == "contractDay").length > 0 ? "input-error" : ""}` }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "contractDay").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uD654\uC7AC \uAC10\uC9C0" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd11" }, { children: [_jsx("input", { type: "radio", id: "rd11", name: "rd11", checked: hasFireDtec, onChange: (e) => handleHasFireDtec(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd21" }, { children: [_jsx("input", { type: "radio", id: "rd21", name: "rd21", checked: !hasFireDtec, onChange: (e) => handleHasFireDtec(false) }), "X"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uBCF4\uD5D8\uAC00\uC785" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd12" }, { children: [_jsx("input", { type: "radio", id: "rd12", name: "rd12", checked: hasInsc, onChange: (e) => handleHasInsc(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd22" }, { children: [_jsx("input", { type: "radio", id: "rd22", name: "rd22", checked: !hasInsc, onChange: (e) => handleHasInsc(false) }), "X"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uD130\uCE58LCD" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd13" }, { children: [_jsx("input", { type: "radio", id: "rd13", name: "rd13", checked: hasTlcd, onChange: (e) => handleHasTlcd(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd23" }, { children: [_jsx("input", { type: "radio", id: "rd23", name: "rd23", checked: !hasTlcd, onChange: (e) => handleHasTlcd(false) }), "X"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC2E0\uC6A9\uCE74\uB4DC \uB9AC\uB354\uAE30" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd14" }, { children: [_jsx("input", { type: "radio", id: "rd14", name: "rd14", checked: hasCardReader, onChange: (e) => handleHasCardReader(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd24" }, { children: [_jsx("input", { type: "radio", id: "rd24", name: "rd24", checked: !hasCardReader, onChange: (e) => handleHasCardReader(false) }), "X"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uAC04\uD3B8\uACB0\uC81C \uAE30\uB2A5" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd15" }, { children: [_jsx("input", { type: "radio", id: "rd15", name: "rd15", checked: hasSimplePay, onChange: (e) => handleHasSimplePay(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd25" }, { children: [_jsx("input", { type: "radio", id: "rd25", name: "rd25", checked: !hasSimplePay, onChange: (e) => handleHasSimplePay(false) }), "X"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC804\uC6A9 \uC571 \uC11C\uBE44\uC2A4" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd16" }, { children: [_jsx("input", { type: "radio", id: "rd16", name: "rd16", checked: hasAppServ, onChange: (e) => handleHasAppServ(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd26" }, { children: [_jsx("input", { type: "radio", id: "rd26", name: "rd26", checked: !hasAppServ, onChange: (e) => handleHasAppServ(false) }), "X"] }))] })) }))] })] }))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => popColes("pop-01") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => EvSaved("pop-01") }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))] }))] }));
}
function Pop02(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const setReload = useSetRecoilState(reLoad);
    //
    const { pop02Re, setPop02Re, title } = props;
    //
    const [custNm, setCustNm] = useState("");
    const [buyProfit, setBuyProfit] = useState("");
    const [buyProfitEn, setBuyProfitEn] = useState("");
    const [istCost, setIstCost] = useState("");
    const [oprCost, setOprCost] = useState("");
    const [chgFee, setChgFee] = useState("");
    const [chgFeeEn, setChgFeeEn] = useState("");
    const [contractDay, setContractDay] = useState("");
    const [hasFireDtec, setHasFireDtec] = useState(true);
    const [hasInsc, setHasInsc] = useState(true);
    const [hasTlcd, setHasTlcd] = useState(true);
    const [hasCardReader, setHasCardReader] = useState(true);
    const [hasSimplePay, setHasSimplePay] = useState(true);
    const [hasAppServ, setHasAppServ] = useState(true);
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        if (pop02Re) {
            popColes("pop-02");
        }
        if (title) {
            CUTIL.IdScrollIntoView("pop-02", "scrollH");
            setCustNm(title.custNm);
            setBuyProfit(title.buyProfit);
            setBuyProfitEn(title.buyProfitEn);
            setIstCost(title.istCost);
            setOprCost(title.oprCost);
            setChgFee(title.chgFee);
            setChgFeeEn(title.chgFeeEn);
            setContractDay(title.contractDay);
            setHasFireDtec(title.hasFireDtec);
            setHasInsc(title.hasInsc);
            setHasTlcd(title.hasTlcd);
            setHasCardReader(title.hasCardReader);
            setHasSimplePay(title.hasSimplePay);
            setHasAppServ(title.hasAppServ);
            setErrorList([]);
        }
    }, [pop02Re, title]);
    // 회사명 입력
    const handleCustNm = (e) => {
        setCustNm(e.target.value);
    };
    // 구매자 수익 기준 입력
    const handleBuyProfit = (e) => {
        setBuyProfit(e.target.value);
    };
    // 구매자 수익 기준 영문 입력
    const handleBuyProfitEn = (e) => {
        setBuyProfitEn(e.target.value);
    };
    // 충전소 설치비 입력
    const handleIstCost = (e) => {
        setIstCost(CUTIL.inputNum(e.target.value));
    };
    // 위탁운영비 입력
    const handleOprCost = (e) => {
        setOprCost(CUTIL.inputNum(e.target.value));
    };
    // 충전 요금 입려
    const handleChgFee = (e) => {
        setChgFee(e.target.value);
    };
    // 충전 요금 영문 입력
    const handleChgFeeEn = (e) => {
        setChgFeeEn(e.target.value);
    };
    // 계약 기간 입력
    const handleContractDay = (e) => {
        setContractDay(CUTIL.inputNum(e.target.value));
    };
    // 화재 감지 선택
    const handleHasFireDtec = (blooean) => {
        setHasFireDtec(blooean);
    };
    // 보헙가입 선택
    const handleHasInsc = (blooean) => {
        setHasInsc(blooean);
    };
    // 터치LCD 선택
    const handleHasTlcd = (blooean) => {
        setHasTlcd(blooean);
    };
    // 신용카드 리더기 선택
    const handleHasCardReader = (blooean) => {
        setHasCardReader(blooean);
    };
    // 간편결제 기능 선택
    const handleHasSimplePay = (blooean) => {
        setHasSimplePay(blooean);
    };
    // 전용 앱 서비스 선택
    const handleHasAppServ = (blooean) => {
        setHasAppServ(blooean);
    };
    // Ev list 수정
    const EvSavedEidt = (id) => __awaiter(this, void 0, void 0, function* () {
        setRecoilIsLoadingBox(true);
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "PUT",
            appPath: `/energyreport/evmngt/${title.id}`,
            appQuery: {
                powerCode: title.sub.code,
                typeCode: title.type.code,
                custNm: custNm,
                buyProfit: buyProfit,
                buyProfitEn: buyProfitEn,
                istCost: istCost,
                oprCost: oprCost,
                chgFee: chgFee,
                chgFeeEn: chgFeeEn,
                contractDay: contractDay,
                hasFireDtec: hasFireDtec,
                hasInsc: hasInsc,
                hasTlcd: hasTlcd,
                hasCardReader: hasCardReader,
                hasSimplePay: hasSimplePay,
                hasAppServ: hasAppServ,
            },
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                popColes(id);
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: "수정 되었습니다.", callBack: () => {
                        setReload(true);
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    });
    // Ev list 삭제
    const EvSavedDelete = (id) => __awaiter(this, void 0, void 0, function* () {
        setRecoilIsLoadingBox(true);
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "DELETE",
            appPath: `/energyreport/evmngt/${title.id}`,
            appQuery: {},
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                popColes(id);
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: data.body, callBack: () => {
                        setReload(true);
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    });
    // 등록 팝업 닫기
    const popColes = (id) => {
        setCustNm("");
        setBuyProfit("");
        setBuyProfitEn("");
        setIstCost("");
        setOprCost("");
        setChgFee("");
        setChgFeeEn("");
        setContractDay("");
        setHasFireDtec(true);
        setHasInsc(true);
        setHasTlcd(true);
        setHasCardReader(true);
        setHasSimplePay(true);
        setHasAppServ(true);
        setErrorList([]);
        setPop02Re(false);
        CUTIL.jsclose_Popup(id);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body pb-0" }, { children: [title && (_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: title.code.description }), _jsx("li", { children: title.sub.description }), _jsx("li", { children: title.type.description })] }))), _jsxs("div", Object.assign({ className: "mt-32" }, { children: [_jsx("h2", { children: "\uC804\uAE30\uCC28 \uCDA9\uC804\uAE30 \uC815\uBCF4" }), _jsxs("ul", Object.assign({ className: "form__input scrollH h440 pb-30 gap16" }, { children: [_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uC81C\uC870\uC0AC ", _jsx("span", Object.assign({ className: "fontRegular" }, { children: "(\uD68C\uC0AC \uBA85)" }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp_1", value: custNm, onChange: (e) => handleCustNm(e), placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694" }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uAD6C\uB9E4\uC790 \uC218\uC775 \uAE30\uC900" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp_2", value: buyProfit, onChange: (e) => handleBuyProfit(e), placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694." }) }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uAD6C\uB9E4\uC790 \uC218\uC775 \uAE30\uC900 ", _jsx("span", Object.assign({ className: "fontRegular" }, { children: "(\uC601\uBB38)" }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp_3", value: buyProfitEn, onChange: (e) => handleBuyProfitEn(e), placeholder: "\uC601\uBB38\uC73C\uB85C \uC785\uB825\uD558\uC138\uC694." }) }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uCDA9\uC804\uC18C \uC124\uCE58\uBE44", _jsx("br", {}), _jsx("span", Object.assign({ className: "fontRegular" }, { children: "(KRW)" }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp_4", value: istCost, onChange: (e) => handleIstCost(e), placeholder: "\uC22B\uC790\uB9CC \uC785\uB825\uD558\uC138\uC694." }) }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uC704\uD0C1\uC6B4\uC601\uBE44", _jsx("span", Object.assign({ className: "fontRegular" }, { children: "(KRW)" }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp_3", value: oprCost, onChange: (e) => handleOprCost(e), placeholder: "\uC22B\uC790\uB9CC \uC785\uB825\uD558\uC138\uC694." }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uCDA9\uC804\uC694\uAE08" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp_5", value: chgFee, onChange: (e) => handleChgFee(e), placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694." }) }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uCDA9\uC804\uC694\uAE08 ", _jsx("span", Object.assign({ className: "fontRegular" }, { children: "(\uC601\uBB38)" }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp_6", value: chgFeeEn, onChange: (e) => handleChgFeeEn(e), placeholder: "\uC601\uBB38\uC73C\uB85C \uC785\uB825\uD558\uC138\uC694." }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uACC4\uC57D \uAE30\uAC04" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp_7", value: contractDay, onChange: (e) => handleContractDay(e), placeholder: "\uC22B\uC790\uB9CC \uC785\uB825\uD558\uC138\uC694." }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uD654\uC7AC \uAC10\uC9C0" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd_11" }, { children: [_jsx("input", { type: "radio", id: "rd_11", name: "rd_11", checked: hasFireDtec, onChange: (e) => handleHasFireDtec(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd_21" }, { children: [_jsx("input", { type: "radio", id: "rd_21", name: "rd_21", checked: !hasFireDtec, onChange: (e) => handleHasFireDtec(false) }), "X"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uBCF4\uD5D8\uAC00\uC785" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd_12" }, { children: [_jsx("input", { type: "radio", id: "rd_12", name: "rd_12", checked: hasInsc, onChange: (e) => handleHasInsc(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd_22" }, { children: [_jsx("input", { type: "radio", id: "rd_22", name: "rd_22", checked: !hasInsc, onChange: (e) => handleHasInsc(false) }), "X"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uD130\uCE58LCD" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd_13" }, { children: [_jsx("input", { type: "radio", id: "rd_13", name: "rd_13", checked: hasTlcd, onChange: (e) => handleHasTlcd(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd_23" }, { children: [_jsx("input", { type: "radio", id: "rd_23", name: "rd_23", checked: !hasTlcd, onChange: (e) => handleHasTlcd(false) }), "X"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC2E0\uC6A9\uCE74\uB4DC \uB9AC\uB354\uAE30" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd_14" }, { children: [_jsx("input", { type: "radio", id: "rd_14", name: "rd_14", checked: hasCardReader, onChange: (e) => handleHasCardReader(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd_24" }, { children: [_jsx("input", { type: "radio", id: "rd_24", name: "rd_24", checked: !hasCardReader, onChange: (e) => handleHasCardReader(false) }), "X"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uAC04\uD3B8\uACB0\uC81C \uAE30\uB2A5" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd_15" }, { children: [_jsx("input", { type: "radio", id: "rd_15", name: "rd_15", checked: hasSimplePay, onChange: (e) => handleHasSimplePay(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd_25" }, { children: [_jsx("input", { type: "radio", id: "rd_25", name: "rd_25", checked: !hasSimplePay, onChange: (e) => handleHasSimplePay(false) }), "X"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC804\uC6A9 \uC571 \uC11C\uBE44\uC2A4" })), _jsx("div", Object.assign({ className: "input__area w160" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd_16" }, { children: [_jsx("input", { type: "radio", id: "rd_16", name: "rd_16", checked: hasAppServ, onChange: (e) => handleHasAppServ(true) }), "O"] })), _jsxs("label", Object.assign({ htmlFor: "rd_26" }, { children: [_jsx("input", { type: "radio", id: "rd_26", name: "rd_26", checked: !hasAppServ, onChange: (e) => handleHasAppServ(false) }), "X"] }))] })) }))] })] }))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-white js-close", onClick: (e) => EvSavedDelete("pop-02") }, { children: _jsx("span", { children: "\uC0AD\uC81C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => EvSavedEidt("pop-02") }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))] }))] }));
}
